const {getEnvironmentCode} = require('./urlService');

const getRunConfig = () => {
    const runConfig = typeof sessionStorage !== "undefined" && JSON.parse(sessionStorage.getItem('run-config'));

    if (!runConfig) {
        throw new Error('No runConfig is set. If in lambda, information needs to be passed in.')
    }

    return runConfig;
};

const getCountry = () => {
    return getRunConfig().country;
};

const getEnvCode = () => {
    return getEnvironmentCode();
};

const getClientId = () => {
    return getRunConfig().clientId;
};

module.exports = {
    getCountry,
    getEnvCode,
    getClientId
};
